import React from 'react'
import CorporateMemberForm from '../../features/corporateMemberTaskList/CorporateForm'

const CorporateMember = () => {
    return (
        <CorporateMemberForm />
    )
}

export default CorporateMember